import React from "react";
import { motion, AnimatePresence } from "framer-motion";

const DeloadConfirmModal = ({ show, onCancel, onConfirm }) => (
  <AnimatePresence>
    {show && (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 bg-black/60 flex items-center justify-center z-[60] p-4"
        onClick={onCancel}
      >
        <motion.div
          initial={{ scale: 0.9 }}
          animate={{ scale: 1 }}
          exit={{ scale: 0.9 }}
          className="bg-[#141B2D] border border-[#1E293B] rounded-xl p-6 max-w-sm w-full"
          onClick={(e) => e.stopPropagation()}
        >
          <h3 className="font-heading text-lg font-bold text-yellow-400 mb-4">Apply Deload?</h3>
          <p className="text-sm text-gray-300 mb-2">
            This will cut all reps in half (rounded up). Sets and percentages stay the same.
          </p>
          <div className="flex gap-3 mt-4">
            <button
              type="button"
              onClick={onCancel}
              className="flex-1 bg-[#2D3B4F] text-white py-3 rounded-lg font-medium"
              data-testid="cancel-deload-btn"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={onConfirm}
              className="flex-1 bg-yellow-600 text-white py-3 rounded-lg font-medium"
              data-testid="confirm-deload-btn"
            >
              Yes, Apply Deload
            </button>
          </div>
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
);

export default DeloadConfirmModal;
